import React from 'react';
import { Banner, Chip } from './ui';
import { GATE_ACCOUNTABILITY_SEVERITY } from '../lib/gateAccountability';

function severityTone(severity) {
  if (severity === GATE_ACCOUNTABILITY_SEVERITY.WILL_MISS || severity === GATE_ACCOUNTABILITY_SEVERITY.IMPOSSIBLE) {
    return 'red';
  }
  if (severity === GATE_ACCOUNTABILITY_SEVERITY.AT_RISK) return 'amber';
  return '';
}

function severityLabel(severity) {
  if (severity === GATE_ACCOUNTABILITY_SEVERITY.IMPOSSIBLE) return 'IMPOSSIBLE';
  if (severity === GATE_ACCOUNTABILITY_SEVERITY.WILL_MISS) return 'WILL MISS';
  if (severity === GATE_ACCOUNTABILITY_SEVERITY.AT_RISK) return 'AT RISK';
  return 'ON PACE';
}

/**
 * One highlighted accountability band — Command + Attention share this language.
 */
export function GateAccountabilityBand({ accountability, go, compact }) {
  const a = accountability;
  if (!a || a.quiet || a.severity === GATE_ACCOUNTABILITY_SEVERITY.ON_PACE) return null;
  const tone = severityTone(a.severity);
  const math = a.math || {};

  return (
    <section className="section">
      <Banner tone={tone || 'amber'}>
        <div className="row" style={{ alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' }}>
          <Chip tone={tone || 'amber'}>{severityLabel(a.severity)}</Chip>
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ fontWeight: 650 }}>
              {a.scream || `${a.gateLabel} needs Critical/High work this week.`}
            </div>
            <div className="dim tiny" style={{ marginTop: 6 }}>
              {a.daysRemainingToGate != null ? `${a.daysRemainingToGate} day(s) to ${a.gateLabel}` : a.gateLabel}
              {math.missingRequiredCount != null ? ` · ${math.missingRequiredCount} missing required` : ''}
              {math.atRiskCount != null ? ` · ${math.atRiskCount} at risk` : ''}
              {math.openCriticalHighOnGate != null
                ? ` · ${math.openCriticalHighOnGate} Critical/High open on gate`
                : ''}
            </div>
            {!compact && (a.miraclePath || []).length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div className="dim tiny" style={{ marginBottom: 6 }}>
                  If you still need to hit it, these are the only moves that matter:
                </div>
                <ol style={{ margin: 0, paddingLeft: 18 }}>
                  {a.miraclePath.map((m, i) => (
                    <li key={`${m.text}-${i}`} style={{ marginBottom: 4 }}>
                      {m.actionId && go ? (
                        <button
                          type="button"
                          className="btn sm ghost"
                          style={{ padding: 0, height: 'auto', fontWeight: 600 }}
                          onClick={() => go('actions')}
                        >
                          {m.text}
                        </button>
                      ) : (
                        <span style={{ fontWeight: 600 }}>{m.text}</span>
                      )}
                      {m.why ? <span className="dim tiny"> — {m.why}</span> : null}
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>
        </div>
      </Banner>
    </section>
  );
}
